<div id="side-bar-container" [ngClass]="{ toggled: burgerOpen, 'small-drawer': !burgerOpen && innerWidth < 1000 }" class="side-bar-container">
  <div class="scroll-container">
    <button type="button" id="main-information-section" (click)="setActiveSection(-1)" [ngClass]="{ active: -1 === activeSectionIndex }" class="bar-item">
      <span [ngClass]="{ zero: miDoc === 0 }" [style.width]="miDoc | percent" class="filler"></span>
      <span class="title">{{ miTitle | translate }}</span>
    </button>
    @for (item of template?.sections; track item; let i = $index) {
      <button
        id="section-side-bar-{{ i }}"
        type="button"
        (click)="setActiveSection(i)"
        [ngClass]="{ active: i === activeSectionIndex }"
        class="bar-item">
        <span [ngClass]="{ zero: item.doc === 0 }" [style.width]="item.doc | percent" class="filler"></span>
        <span class="title">
          {{ !burgerOpen && innerWidth < 1000 ? i + 2 : getItemTitle(item) }}
        </span>
        @if (innerWidth < 1000 && item.description) {
          <span class="subtitle">
            {{ getItemSubtitle(item) }}
          </span>
        }
      </button>
    }
    <button
      type="button"
      id="document-section"
      (click)="setActiveSection(sections.length)"
      [ngClass]="{ active: sections.length === activeSectionIndex }"
      class="bar-item">
      <span [ngClass]="{ zero: !hasDocument }" [style.width]="(hasDocument ? 1 : 0) | percent" class="filler"></span>
      <span class="title">{{ !burgerOpen && innerWidth < 1000 ? template?.sections?.length + 2 : ("report.actions.documentUpload" | translate) }}</span>
    </button>
  </div>
</div>
